import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d80497c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["min", "max", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    type: "range",
    class: "input-range",
    min: _ctx.props.min,
    max: _ctx.props.max,
    value: _ctx.props.modelValue,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
  }, null, 40, _hoisted_1))
}